<template>
  <NavbarComponent />
  <MainComponent />
  <FooterComponent />
</template>

<script>
import NavbarComponent from './components/NavbarComponent.vue'
import MainComponent from './components/MainComponent.vue'
import FooterComponent from './components/FooterComponent.vue'

export default {
  name: 'App',
  components: {
    NavbarComponent,
    MainComponent,
    FooterComponent
  }
}
</script>
